module.exports = {
  path: '/banner',
  name: 'banner',
  meta: { title: '赛事推荐位', icon: 'el-icon-upload' },
  component: () => import('../views/banner/banner.vue')
}
